<template>
    <li>
      <div
        class="parent mb-1"
        :class="{
          selected: getSelectedRepositoryId === repository.repositorioId
        }"
      >
        <span class="pt-1">
          <vs-icon
            size="small"
            icon="keyboard_arrow_right"
            v-if="!isOpen"
            @click="toggle(repository)"
          />
          <vs-icon
            size="small"
            icon="keyboard_arrow_down"
            v-if="isOpen"
            @click="toggle(repository)"
          />
        </span>
        <span
          class="pt-1"
          @click="selectRepository(repository)"
        >
          <font-awesome-icon :icon="['fas', 'database']" style="color: #205081"/>
        </span>
        <span
          :class="{ 'text-cyan': repository.nombre === 'Mis suscripciones' }"
          class="pt-1 text-sm pl-1"
          @click="selectRepository(repository)"
          v-b-tooltip.hover.bottom="mainRepositoryDescription"
        >
          {{ repository.nombreRepositorio }}
        </span>
        <div v-if="isSuperAdmin">
          <EditRepository />
        </div>
        <span class="spinner-grow spinner-grow-sm text-purple h-4 w-4 mt-2 ml-2"
        v-show="loading"
        />
      </div>
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <ul
          v-if="isOpen"
          class="border-0 border-l-2 border-double left-0 pl-3 border-grey-light"
        >
          <!-- FOLDERS -->
          <folders-tree
            v-for="folder in folders"
            :key="folder.carpetaId"
            :folder="folder"
            :repository-id="repository.repositorioId"
          />
        </ul>
      </transition>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div class="w-100" v-show="loading">
          <b-skeleton class="bg-grey-light border-0 w-48 h-8 mb-3" type="input" animation="fade" />
          <b-skeleton class="bg-grey-light border-0 w-32 h-8 mb-3" type="input" animation="fade" />
          <b-skeleton class="bg-grey-light border-0 w-64 h-8 mb-3" type="input" animation="fade" />
          <div class="d-flex w-100">
            <b-skeleton class="bg-grey-light border-0 w-3 h-3 ml-3" type="text" animation="fade" />
            <b-skeleton class="bg-grey-light border-0 w-3 h-3 ml-1" type="text" animation="fade" />
            <b-skeleton class="bg-grey-light border-0 w-3 h-3 ml-1" type="text" animation="fade" />
          </div>
        </div>
      </transition>
    </li>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';

import EditRepository from '@/febos/global/documentManagement/components/EditRepository';
import FoldersTree from '@/febos/global/documentManagement/components/FoldersTree';

library.add(faDatabase);

export default {
  name: 'repositories-tree',
  props: {
    repository: {}
  },
  components: {
    FoldersTree,
    EditRepository
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      folders: [],
      mainRepositoryDescription: null
    };
  },
  methods: {
    toggle(repository) {
      this.isOpen = !this.isOpen;
      if (this.folders.length === 0) {
        // this.selectFolder();
        this.selectRepository(repository);
        // this.getFolders(this.repository);
      }
    },
    selectFolder() {
      const fullpath = `${this.folder.repositoryId }/${ this.folder.fullpathId }/${ this.folder.carpetaId}`;
      this.$router.replace(
        {
          name: 'document-management',
          query: { ...this.$route.query, path: `/${fullpath}` }
        }
      );
      // this.getFolders();
    },
    async getFolders() {
      this.loading = true;
      this.isOpen = true;
      // this.selectRepository(this.repository.repositorioId);
      // this.setSelectedRepository(this.repository.repositorioId);
      await this.loadTree({
        repositoryId: this.repository.repositorioId,
        parentFolder: null,
        path: '/'
      });
      await this.loadFiles({
        repositoryId: this.repository.repositorioId,
        parentFolder: null,
        path: '/',
      });
      this.loading = false;
    },
    selectRepository(repository) {
      const { name } = this.$route;
      if (name === 'document-management') {
        window.history.pushState(
          {},
          null,
          `${this.$route.path }#/${this.repository.repositorioId}`
        );
      }
      this.setSelectedRepository(repository.repositorioId);
      this.getFolders();
    },
    ...mapActions('DocManagement', [
      'loadTree',
      'loadFiles',
      'setSelectedRepository',
    ]),
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getTreeElements',
      'getRepositories',
    ]),
    ...mapGetters('Usuario', [
      'hasPermission'
    ]),
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    }
  },
  updated() {
    const { descripcion } = Object.values(this.getRepositories)[0];
    this.mainRepositoryDescription = descripcion;
  },
  created() {
    const { descripcion } = Object.values(this.getRepositories)[0];
    this.mainRepositoryDescription = descripcion;
  },
  mounted() {
    const firstRepoId = Object.keys(this.getRepositories)[0];
    if (firstRepoId === this.repository.repositorioId) {
      this.setSelectedRepository(firstRepoId);
      this.getFolders();
    }
  },
  watch: {
    getTreeElements() {
      this.folders = Object.values(this.getTreeElements)
        .filter((element) => (
          element.parentFolder === null && element.repositoryId === this.repository.repositorioId
        ));
    },
  },
};
</script>
<style lang='scss' scoped>
.item {
  cursor: pointer;
  list-style: none;
}
.parent {
  font-weight: bold;
}
ul {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 1em;
  line-height: 1.5em;
}
li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.selected {
  border-radius: 5px;
  width: fit-content;
  padding-right: 10px;
  background: lightgray;
}
</style>
